import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";

import PageNameV2 from "../common/PageNameV2";
import PageTitleV2 from "../common/PageTitleV2";
import ShopSelectBoxV2 from "../common/ShopSelectBoxV2";
import ShopCategoryV2 from "./ShopCategoryV2";
import ShopImgV2 from "./ShopImgV2";

import {getUserId, getUserType} from "../../../static/js/Common";
import {useGetStoreListApi} from "../../../static/js/hock/shopHock";
import {formatService} from "../../../static/js/service/userService";
import {formatStatus} from "../../../static/js/service/formatService";
import {subNavEvent} from "../../../static/js/service/commonService";

export default function ShopV2() {
  const [shopList, setShopList] = useState([]);
  const userId = getUserId();
  const userType = getUserType();
  const navigate = useNavigate();

  useGetStoreListApi({setShopList}, userId, userType);

  useEffect(() => {
    subNavEvent("shopNav", "shop");
  }, []);

  const itemBox = shopList.map((value) => {
    const shopClickEvent = () => {
      navigate(`/v2/shopInfo1?shopSelect=${value.id}`);
    }

    return (
      <div className="shopList pt-15 pb-15 d-flex a-start" key={value.id}>
        <div className="shopLogo mr-20">
          <ShopImgV2 shopId={value.id} />
        </div>
        <div className="shopTextBox" onClick={shopClickEvent}>
          <h3 className="d-flex a-center j-left fs-20">
            {userType === 4 ? value.shopName : value.storeName}
            <div className={`statusBox ml-5 pr-10 pl-10 fs-16 ${value.statusTpcd === 6 ? "" : "redBox"}`}>
              {formatStatus(value.statusTpcd)}
            </div>
          </h3>
          <p>{formatService(value.serviceTpcd)}</p>
          <ShopCategoryV2 shopId={value.id} />
        </div>
      </div>
    );
  });

  return (
    <main id="shopV2" className="mainV2">
      <div className="container scrollbar">
        <section className="containerInner">
          <PageNameV2 title1="상점 관리" title2="상점 운영 목록" />
          <div className="pageTitle mb-10 d-flex a-center j-between">
            <PageTitleV2 title="상점 운영 목록" countText="전체 상점 총 " count={shopList.length} unit="개" />
            {/*<div>
              {userType !== 4 &&
                <button
                  type="button" id="newShopBtn" className="commonBtn blueBtn"
                  onClick={() => window.location.href = "/v2/newShop"}
                >
                  상점 신규 신청
                </button>
              }
            </div>*/}
          </div>

          <div id="shopSelectBox" className="hide">
            <ShopSelectBoxV2 url="/v2/shopInfo1" />
          </div>

          <div className="shopListBox listBox bg-white pt-5 pr-15 pb-5 pl-15 mb-50">
            {itemBox}
          </div>
        </section>
      </div>
    </main>
  )
}